var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadMyNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 60,
    viewBox: "0 0 94 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7983_732)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62567 0.522644H88.3743C91.2383 0.522644 93.4886 2.8223 93.4886 5.74913V54.2509C93.4886 57.1777 91.2383 59.4774 88.3743 59.4774H5.62567C2.76169 59.4774 0.511414 57.1777 0.511414 54.2509V5.74913C0.511414 2.8223 2.76169 0.522644 5.62567 0.522644Z",
    fill: "url(#paint0_linear_7983_732)",
    stroke: "#B6B6B6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3743 1.0453C90.9314 1.0453 92.9771 3.13589 92.9771 5.74913V54.2509C92.9771 56.8641 90.9314 58.9547 88.3743 58.9547H5.62568C3.06855 58.9547 1.02285 56.8641 1.02285 54.2509V5.74913C1.02285 3.13589 3.06855 1.0453 5.62568 1.0453H88.3743ZM88.3743 0H5.62568C2.55713 0 0 2.61324 0 5.74913V54.2509C0 57.4913 2.55713 60 5.62568 60H88.3743C91.4429 60 94 57.3868 94 54.2509V5.74913C94 2.61324 91.4429 0 88.3743 0Z",
    fill: "#B6B6B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.272 29.0592H40.6072V51.0105H88.272V29.0592Z",
    fill: "#F0F5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3808 7.83972H6.85309V9.72126H48.3808V7.83972Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3808 12.7526H6.85309V14.6342H48.3808V12.7526Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4309 6.06271H79.9869C79.1396 6.06271 78.4526 6.76471 78.4526 7.63066V14.216C78.4526 15.082 79.1396 15.784 79.9869 15.784H86.4309C87.2782 15.784 87.9652 15.082 87.9652 14.216V7.63066C87.9652 6.76471 87.2782 6.06271 86.4309 6.06271Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9597 34.2857H86.2263",
    stroke: "#CADFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9597 40.2439H86.2263",
    stroke: "#CADFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9597 46.0976H86.2263",
    stroke: "#CADFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7983_732",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 21,
    width: 27,
    height: 31
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2198 21.0104H6.95538V51.0104H32.2198V21.0104Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7983_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2198 21.0104H6.95538V51.0104H32.2198V21.0104Z",
    fill: "#CADFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4342 38.1533C23.219 38.1533 26.2873 35.0177 26.2873 31.1498C26.2873 27.2819 23.219 24.1463 19.4342 24.1463C15.6493 24.1463 12.5811 27.2819 12.5811 31.1498C12.5811 35.0177 15.6493 38.1533 19.4342 38.1533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.605 39.1986H16.161C13.0541 39.1986 10.5354 41.7726 10.5354 44.9477V55.4007C10.5354 58.5758 13.0541 61.1498 16.161 61.1498H22.605C25.712 61.1498 28.2307 58.5758 28.2307 55.4007V44.9477C28.2307 41.7726 25.712 39.1986 22.605 39.1986Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7983_732",
    x1: 0.511414,
    y1: 30,
    x2: 93.4886,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E4C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7983_732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadMyNumber);
export default __webpack_public_path__ + "static/media/bad_myNumber.b07e63f35b1c09e0389f50527ff644dc.svg";
export { ForwardRef as ReactComponent };